import { combineReducers } from 'redux';

import auth from './auth/reducer';
import beneficiarie from './beneficiarie/reducer';

export default combineReducers({
  auth,
  beneficiarie,
});
